import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('role', [
            'available_roles',
        ])
    },
    methods: {
        ...mapActions('role', [
            'fetch_available_roles',
        ]),
    },
}